// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReducedPlanYearDto } from './IReducedPlanYearDto';
import {
    IReducedPlanYearDtoFromJSON,
    IReducedPlanYearDtoFromJSONTyped,
    IReducedPlanYearDtoToJSON,
    IReducedPlanYearDtoToJSONTyped,
} from './IReducedPlanYearDto';

/**
 * 
 * @export
 * @interface ISpendLimitPeriodDto
 */
export interface ISpendLimitPeriodDto {
    /**
     * 
     * @type {string}
     * @memberof ISpendLimitPeriodDto
     */
    spend_period_type?: ISpendLimitPeriodDtoSpendPeriodTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ISpendLimitPeriodDto
     */
    period_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ISpendLimitPeriodDto
     */
    period_end?: Date;
    /**
     * 
     * @type {Array<IReducedPlanYearDto>}
     * @memberof ISpendLimitPeriodDto
     */
    plan_years?: Array<IReducedPlanYearDto>;
}

/**
* @export
* @enum {string}
*/
export enum ISpendLimitPeriodDtoSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}


/**
 * Check if a given object implements the ISpendLimitPeriodDto interface.
 */
export function instanceOfISpendLimitPeriodDto(value: object): value is ISpendLimitPeriodDto {
    return true;
}

export function ISpendLimitPeriodDtoFromJSON(json: any): ISpendLimitPeriodDto {
    return ISpendLimitPeriodDtoFromJSONTyped(json, false);
}

export function ISpendLimitPeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISpendLimitPeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
        'period_start': json['period_start'] == null ? undefined : (new Date(json['period_start'])),
        'period_end': json['period_end'] == null ? undefined : (new Date(json['period_end'])),
        'plan_years': json['plan_years'] == null ? undefined : ((json['plan_years'] as Array<any>).map(IReducedPlanYearDtoFromJSON)),
    };
}

export function ISpendLimitPeriodDtoToJSON(json: any): ISpendLimitPeriodDto {
    return ISpendLimitPeriodDtoToJSONTyped(json, false);
}

export function ISpendLimitPeriodDtoToJSONTyped(value?: ISpendLimitPeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spend_period_type': value['spend_period_type'],
        'period_start': value['period_start'] == null ? undefined : ((value['period_start']).toISOString().substring(0,10)),
        'period_end': value['period_end'] == null ? undefined : ((value['period_end']).toISOString().substring(0,10)),
        'plan_years': value['plan_years'] == null ? undefined : ((value['plan_years'] as Array<any>).map(IReducedPlanYearDtoToJSON)),
    };
}

